import Vue from 'vue'

import sysInput from './Basic/sysInput'
import sysSelect from './Basic/sysSelect'

Vue.component('sys-input', sysInput)
Vue.component('sys-select', sysSelect)



// WEBPACK FOOTER //
// ./src/components/index.js